import React, { Component } from "react";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import { withTranslation } from 'react-i18next';


import AuthService from "../../utils/auth.service";
import ShowValue from "../../components/ShowValue";
import ApiAssets from "../../utils/api.assets";
import Loading from "../../components/Loading";
import MessageModal from "../../components/Message";

class ProfilePage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      img_url: AuthService.registerData.photoURL,
      profile: AuthService.profileUser,

      profile_classets: {
        my_classets: [],
        prev_classets: [],
        auction_classets: []
      },

      modal: {
        isOpen: false,
        title: "",
        message: ""
      },
      loading: true,
      adminSiteClicks: {}
    };

    document.addEventListener("profileLoaded", data => {
      if (data.detail) {
        this.setState(...this.state, {
          profile: data.detail.profile
        });
      }
    });

    //todo: resolver company_code
    

    this.handleInput = this.handleInput.bind(this);
    this.handleSubmitProfile = this.handleSubmitProfile.bind(this);
    this.toggleAlert = this.toggleAlert.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.clicksToAdminSite = this.clicksToAdminSite.bind(this);
  }
  
  componentDidMount() {
  	
  	if (this.state.profile) {
		  ApiAssets.getMy(2, this.state.profile.uid).then(response => {
			  if (response.data) {
				  let total_asset_value = 0;
				
				  response.data.my_classets.forEach(classet => {
					  total_asset_value += classet.info.previous_owners[0].previous_owner_asset_price * 1.2;
				  });
				
				  this.setState(...this.state, {
					  loading: false, total_asset_value: total_asset_value, profile_classets: response.data
				  });
			  }
		  }).catch(error => {
			  this.setState(...this.state, {loading: false });
		  });
	  }
  }

  clicksToAdminSite(type) {
    if (type !== undefined && type !== null) {
      let clicks = this.state.adminSiteClicks[type];
      if (clicks) {
        clicks++;
        if (clicks > 5) {
          window.open('https://winvite.io/');
          clicks = 1;
        }
      } else {
        clicks = 1;
      }
      this.setState(...this.state, {
        adminSiteClicks: {
          [type]: clicks
        }
      });
    }
  }

  toggleAlert() {
    this.setState(...this.state, {
      modal: { isOpen: !this.state.modal.isOpen }
    });
  }

  handleInput(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    let profile = this.state.profile;
    profile[name] = value;

    this.setState(...this.state, { profile: profile });
  }

  handleSubmitProfile() {
    this.setState(...this.state, { loading: true });

    AuthService.update(this.state.profile, "regular").then(data => {
      this.setMessage("All changes were saved", data.message);
    }).catch(() => {
      this.setMessage(
        "Ooppps",
        "Something wrong happened (probably bad nerwork), try again soon..."
      );
    });
  }

  setMessage(title, message) {
    this.setState(...this.state, {
      modal: { title: title, message: message, isOpen: true },
      loading: false
    });
  }

  handleBack() {
  	this.props.history.goBack();
  }
  
  addInfluencer() {
  }
  
  

  render() {
  	
  	const { t } = this.props;
  	
    return (
      <section className="profile-page">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <h4 className="pt-4">{t('profile.myprofile')}</h4>
              <button onClick={this.handleBack} className="btn btn-outline-secondary float-left">
	              {t('common.back')}
              </button>{" "}
              <Button className="float-right" color="secondary ml-2" onClick={() => this.handleSubmitProfile()} type="submit">
	              {t('common.save')}
              </Button>{" "}
              {/* Back */}
            </div>
            <hr />
          </div>
          <hr />
          <div className="row justify-content-center">
            <div className="col-md-2">
              <img className="img-fluid rounded-circle mt-2" alt="decorative profile" src={this.state.img_url} onClick={() => { this.clicksToAdminSite('go-to-admin') }} />
            </div>{" "}
            {/* Image */}
            <div className="col-md-6">
              <label htmlFor="name">{t('profile.winnersname')}</label>
              <input type="text" className="form-control mb-2"
                     onChange={this.handleInput}
                     value={this.state.profile ? this.state.profile.name : 'Error name'} name="name" />
            </div>

          </div>{" "}
          {/* Body */}

          {/* Buttons */}
        </div>
	      
        <div className="container" hidden={!this.state.profile }>
          <div className="row justify-content-center">
            <div className="col-md-4">
              <h4 className="pt-4">{t('profile.mywinvites')}</h4>
	            <p> {t('profile.winnerwinvites')} </p>

              <hr />
              <ul className="list-unstyled m-0 p-0"
                  hidden={!this.state.profile || this.state.profile_classets.my_classets.length === 0}>

                {this.state.profile_classets.my_classets.map((asset, index) => (
                  <Link key={index}
                        onClick={this.props.toggle}
                        to={"/assets/?assetline=" + asset.assetline} >
                    <div className="row row-item" key={asset.info.name}>
                      <div className="col-md-3">
                        <img className="img-fluid" alt="" src={asset.info.image} />
                      </div>
                      <div className="col-md-9">
                        {asset.info.name} <br />
	                      {t('profile.sellingprice')}{" "}
                        <ShowValue btc={asset.info.previous_owners[0].previous_owner_asset_price} />
                        <br />
                      </div>
                    </div>
                  </Link>
                ))}
              </ul>
              <div className="col-md-8">
              <hr />
              {/*<p className="float-right">*/}
                {/*Total:*/}
                {/*<strong>*/}
                  {/*{" "}*/}
	                <ShowValue btc={this.state.total_asset_value} />
                {/*</strong>*/}
              {/*</p>*/}
            </div>{" "}
              <p hidden={!this.state.profile || this.state.profile_classets.my_classets.length !== 0}>
                Você não tem lances vencedores...
              </p>
            </div>{" "}

            {/* My Classets */}
            
            <div className="col-md-4">
              <h4 className="pt-4">{t('profile.myprevious')} </h4>
              <p> {t('profile.soldwinvites')}  </p>
              <hr />
              <ul className="list-unstyled m-0 p-0" hidden={!this.state.profile || this.state.profile_classets.prev_classets.length === 0} >
                {this.state.profile_classets.prev_classets.map(asset => (
                  <Link onClick={this.props.toggle} to={"/assets/?assetline=" + asset.assetline}>
                    <div className="row row-item" key={asset.info.name}>
                      <div className="col-md-3">
                        <img className="img-fluid" alt="" src={asset.info.image} />
                      </div>
                      <div className="col-md-9">
                        {asset.info.name} <br />
                      </div>
                    </div>
                  </Link>
                ))}
              </ul>
              <p hidden={this.state.profile_classets.prev_classets.length !== 0} >
	              {t('profile.youdidnot')}
              </p>
            </div>{" "}
            
            {/* Previous Assets */}

            {/* Balance when sold */}
          </div>

        </div>
	       
	      
	      {/*<div className="container" hidden={this.state.profile.agent}>
		      <Link className="btn btn-outline-success float-right"
		      to="profile/agent">
	              {t('profile.add')}
	        </Link>{" "}
		      
	      </div>*/}
	      
        <Loading active={this.state.loading} />
        <MessageModal isOpen={this.state.modal.title}
                      toggle={this.toggleAlert}
                      title={this.state.modal.title}
                      message={this.state.modal.message} />
      </section>
    );
  }
}

export default withTranslation()(ProfilePage);



// WEBPACK FOOTER //
// ./src/containers/ProfilePage/index.js